import axios from 'axios'

const showCardPackages = async (cardId) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/viewAllCardsPackages/${cardId}`,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data.data
  } catch (error) {}
}

export default showCardPackages
